import { Popover } from '@mui/material';
import React from 'react';
import { EventMapItem } from '../../../types/Event';
import EventMapTile from './EventMapTile';

export interface EventMapPopupState {
  anchorEl: HTMLElement | null;
  mapEvent: EventMapItem | null;
}

interface Props {
  popupState: EventMapPopupState;
  onClose: () => void;
}

export default function EventMapItemPopover({ popupState, onClose }: Props) {
  const { anchorEl, mapEvent } = popupState;

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'divider',
          maxWidth: 420,
          p: 1,
        },
      }}
    >
      {mapEvent && <EventMapTile mapEvent={mapEvent} />}
    </Popover>
  );
}
